import { SMIME_EDGE_CHROMIUM_EXTENSION_URL } from './constants';
import { isBrowserEDGECHROMIUM } from 'owa-user-agent';

export default function openExtensionLinkInEdgeStore() {
    if (isBrowserEDGECHROMIUM()) {
        window.open(SMIME_EDGE_CHROMIUM_EXTENSION_URL, '_blank');
    }
}
